"use strict";
/**
 * @file Created on Mon Dec 21 2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var immutable_1 = require("immutable");

var WindowWarningFlag_1 = require("./WindowWarningFlag");
/**
 * @author Tomas Leity
 */


var WindowWarningFlagSets =
/*#__PURE__*/
function () {
  function WindowWarningFlagSets() {
    _classCallCheck(this, WindowWarningFlagSets);
  }

  _createClass(WindowWarningFlagSets, null, [{
    key: "constructorNames",

    /**
     * Gets constructor names from {@link WindowWarningFlag} collection.
     * @param ctorCollection Collection of warning flag constructors
     */
    value: function constructorNames(ctorCollection) {
      return ctorCollection.map(function (ctor) {
        return ctor.name;
      }).toSet();
    }
  }]);

  return WindowWarningFlagSets;
}();

exports.WindowWarningFlagSets = WindowWarningFlagSets;
/**
 * Flags that throws instant error after validation for {@link Window} workflow transition.
 */

WindowWarningFlagSets.INSTANT_ERROR_SESSION_SAVE = immutable_1.Set.of(WindowWarningFlag_1.ValueMissingLeafletText, WindowWarningFlag_1.ValueMissingPageNumber, WindowWarningFlag_1.PromoPriceValidityStartInvalid, WindowWarningFlag_1.WindowAffectedByCategoryChange);